import { QueryHookOptions, gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'

const query = gql`
  query FetchCategoryArticles($slug: String!, $page: Int!, $limit: Int!, $sort: String) {
    fetchArticlesByCategory(
      category: $slug,
      page: $page,
      limit: $limit,
      sort: $sort
    ) {
      page
      totalPages
      totalDocs
      docs {
        id
        title
        shortDescription
        featuredImage {
          url
          alt
        }
        primaryCategory {
          name
          slug
        }
        slug
      }
    }
  }
`

export enum CategoryArticlesSort {
  CreatedAtAsc = 'createdAt',
  CreatedAtDesc = '-createdAt',
}

export interface CategoryArticlesQueryInput {
  slug: string
  page: number
  limit: number
  sort?: CategoryArticlesSort
}

export interface CategoryArticlesQueryOutput {
  fetchArticlesByCategory: {
    page: number
    totalPages: number
    totalDocs: number
    docs: {
      id: string
      title: string
      shortDescription: string
      featuredImage: {
        url: string
        alt: string
      }
      primaryCategory: {
        name: string
        slug: string
      }
      slug: string
    }[]
  }
}

const defaultVariables = {
  page: 1,
  limit: 6,
  sort: CategoryArticlesSort.CreatedAtDesc,
}

export const useCategoryArticlesQuery = (input: CategoryArticlesQueryInput, options?: QueryHookOptions<CategoryArticlesQueryOutput, CategoryArticlesQueryInput>) =>
  usePersistedCacheQuery<CategoryArticlesQueryOutput, CategoryArticlesQueryInput>(query, { variables: input, ...options })


export const categoryArticlesQuery = { query, defaultVariables }
